import { render, staticRenderFns } from "./familyUpload.vue?vue&type=template&id=6d586988&"
import script from "./familyUpload.vue?vue&type=script&lang=ts&"
export * from "./familyUpload.vue?vue&type=script&lang=ts&"
import style0 from "./familyUpload.vue?vue&type=style&index=0&id=6d586988&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports